export default __webpack_public_path__ + "static/dge_small-image_2-9af49d7a2f2f44839ee5dd6c4900d9d9.webp";